import { rgba } from 'polished';
import styled from 'styled-components';
import Button from 'antd/es/button';

import { cFFFFFF } from '#/colors';

import { useSystemConfig } from '#/features/system/system-config-context';
import { useBuildStarknetContractUrl } from '#/features/starknet';

export default function Contracts() {
  const config = useSystemConfig();
  const token = config.getToken('USDC');

  return (
    <div css="display: grid; gap: 12px;">
      <ContractStarknet title="Paraclear" address={config.paraclear.address} />
      <ContractStarknet
        title={`${token.symbol} Token`}
        address={token.l2TokenAddress}
      />
      <ContractStarknet
        title={`${token.symbol} Bridge`}
        address={token.l2BridgeAddress}
      />
    </div>
  );
}

interface ContractProps {
  readonly title: string;
  readonly address: string;
}

function ContractStarknet(props: ContractProps) {
  const buildStarknetContractUrl = useBuildStarknetContractUrl();
  return (
    <div>
      <Title>Starknet {props.title} contract</Title>{' '}
      <Button
        href={buildStarknetContractUrl(props.address)}
        target="_blank"
        rel="nofollow noopener"
      >
        {props.address}
      </Button>
    </div>
  );
}

const Title = styled.span`
  margin: 0;
  margin-bottom: 2px;
  font-size: 12px;
  font-size: 12px;
  color: ${rgba(cFFFFFF, 0.5)};
`;
